import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgFxButtonComponent } from './button.component';
export { NgFxButtonComponent } from './button.component';
var NgFxButtonModule = (function () {
    function NgFxButtonModule() {
    }
    NgFxButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [NgFxButtonComponent],
                    exports: [NgFxButtonComponent]
                },] },
    ];
    return NgFxButtonModule;
}());
export { NgFxButtonModule };
